import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/store.hook";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import { TitlesTyp } from "../../Typography/Typography";
import { StyledBreadcrumb, StyledBreadcrumbItem } from "./Breadcrumb.styled";
import { IconManager } from "../IconManager/IconManager";
import { ReactComponent as ChevronRightIcon } from "../../../icons/chevronRight.svg";
import React from "react";
import { useEditing } from "../../../providers/editing.provider";

export const Breadcrumb = () => {
  const { breadcrumb } = useAppSelector((state) => state.config);
  const navigate = useNavigate();
  const { confirmLeave, edit } = useEditing();

  const isActive = (index: number, listLength: number) => {
    if (index === listLength - 1) {
      return true;
    }
  };

  return (
    <StyledBreadcrumb>
      {breadcrumb.map((item, index) => (
        <React.Fragment key={`breadcrumb-item-${index}`}>
          <StyledBreadcrumbItem
            {...(item.pathName && {
              onClick: () => {
                edit
                  ? confirmLeave(() => navigate(item.pathName!))
                  : navigate(item.pathName!);
              },
            })}
          >
            <TitlesTyp
              fontWeight={
                isActive(index, breadcrumb.length)
                  ? FontWeightEnum.MEDIUM
                  : FontWeightEnum.REGULAR
              }
              variant="2"
            >
              {item.name}
            </TitlesTyp>
          </StyledBreadcrumbItem>
          {index < breadcrumb.length - 1 && (
            <IconManager size={IconSizeEnum.MEDIUM}>
              <ChevronRightIcon />
            </IconManager>
          )}
        </React.Fragment>
      ))}
    </StyledBreadcrumb>
  );
};
